import React, { useEffect, useState } from "react";
import "./Statistics.scss";
import {
    getAllPractitioners, getMyUser,
    getStatistics, getWellnessStatistics,
} from "../../../../core/axios/services";
import { useSelector } from "react-redux";
import BarChart from "../../../components/Admin Panel/BarChart/BarChart";
import Headline from "../../../components/Comon/Headline/Headline";
import { Box, Checkbox } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomCheckbox from "../../../components/Admin Panel/CustomCheckbox/CustomCheckbox";
import Dropdown from "../../../components/Admin Panel/Dropdown/Dropdown";
import XYDiagram from "../../../components/Admin Panel/XYDiagram/XYDiagram";
import practitioner from "../Practitioner/Practitioner";
import BarChartWellness from "../../../components/Admin Panel/BarChart/BarChartWellness";
import XYDiagramWellness from "../../../components/Admin Panel/XYDiagram/XYDiagramWellness";
// import { Dna } from "react-loader-spinner";

const Statistics = (showGlobalSnackbar) => {
  let [statistics, setStatistics] = useState([]);
  const user = useSelector((state) => state.user);
  const [items, setItems] = useState([]);

  console.log('items',items);

  const { i18n } = useTranslation();
  const [practitioners, setPractitioners] = useState([]);
  const [show, setShow] = useState(true);

  const [clinicUsesOldScale, setClinicUsesOldScale] = useState(false);

  const diagramTypes = [
    { id: 1, name: i18n.t("xDiagram") },
    { id: 2, name: i18n.t("xyDiagram") },
  ];
  const scaleTypes = [
    { id: 0, name: i18n.t("all"), value:'all' },
    { id: 1, name: i18n.t("zeroScale"), value:'zero_scale' },
    { id: 2, name: i18n.t("oneScale"), value:'one_scale' },
  ];

    const surveyGlobalTypes = [
        { id: 0, name: i18n.t("regularSurvey"), value:'regular' },
        { id: 1, name: i18n.t("wellnessSurvey"), value:'wellness' },
    ];
    const [surveyGlobalType, setSurveyGlobalType] = useState(surveyGlobalTypes[0])

  const [selectedDiagram, setSelectedDiagram] = useState(diagramTypes[1]);
  const [selectedScale, setSelectedScale] = useState(scaleTypes[0]);
  const [selectedPractitioner, setSelectedPractitioner] = useState({
    id: 0,
    name: user.user.clinic.name,
  });

  useEffect(() => {
    if(user && user?.user?.clinic?.scaleType === 'one_scale'){
      setClinicUsesOldScale(true);
    }
  },[user]);


  // const [selectedPractitioner, setSelectedPractitioner] = useState([]);
  const [surveyOptions, setSurveyOptions] = useState();

  const [surveyType, setSurveyType] = useState([
    {
      id: 1,
      name: "ChiroForm",
      selected: true,
    },
    {
      id: 2,
      name: "ChiroForm +",
      selected: true,
    },
  ]);

  const [loader, setLoader] = useState(false);

  // useEffect(() => {
  //   getPractitionerLogic();
  // }, []);
  //
  useEffect(() => {
    getPractitionerLogic();
  }, [selectedPractitioner, surveyGlobalType]);

  const getPractitionerLogic = () => {
    setLoader(false);
    let postData = {};
    if (selectedPractitioner) {
      postData.practitionerId = selectedPractitioner.id;
      postData.scaleType = selectedScale?.value;
    }

    if(surveyGlobalType?.value === 'wellness'){
        getWellnessStatistics(postData, user).then((res) => {
            console.log('res',res)
            setLoader(true);
            statistics = res.data.data.data;
            setStatistics(res.data.data.data);
            setSurveyOptions(
                res.data.data.data?.map((item,index) => {
                    return {
                        id:item?.surveyOrder,
                        selected:true,
                    }
                }));

            console.log("res.data.data",res.data.data);

            return getMyUser(user)
                .then((res) => {
                    const wellnessSetting = res.data.data.clinic.wellnessSettings.sort(((a, b) => a.language.id - b.language.id))[0];

                    setItems([
                        {
                            id: 11,
                            property: wellnessSetting?.['healthMetric1PdfTitle'] ?? 'healthMetric1PdfTitle',
                            propertyName: "health_metric_1",
                        },
                        {
                            id: 12,
                            property: wellnessSetting?.['healthMetric2PdfTitle'] ?? 'healthMetric2PdfTitle',
                            propertyName: "health_metric_2",
                        },
                        {
                            id: 13,
                            property: wellnessSetting?.['healthMetric3PdfTitle'] ?? 'healthMetric3PdfTitle',
                            propertyName: "health_metric_3",
                        },
                        {
                            id: 14,
                            property: wellnessSetting?.['healthMetric4PdfTitle'] ?? 'healthMetric4PdfTitle',
                            propertyName: "health_metric_4",
                        },
                        {
                            id: 15,
                            property: wellnessSetting?.['healthMetric5PdfTitle'] ?? 'healthMetric5PdfTitle',
                            propertyName: "health_metric_5",
                        },
                        {
                            id: 16,
                            property: wellnessSetting?.['healthMetric6PdfTitle'] ?? 'healthMetric6PdfTitle',
                            propertyName: "health_metric_6",
                        },
                    ]);
                });
        });

    }else if(surveyGlobalType?.value === 'regular'){
        getStatistics(postData, user).then((res) => {
            setLoader(true);
            statistics = res.data.data;
            setStatistics(res.data.data);
            setSurveyOptions([
                {
                    id: 1,
                    selected: true,
                },
                {
                    id: 2,
                    selected: true,
                },
                {
                    id: 3,
                    selected: true,
                },
                {
                    id: 4,
                    selected: true,
                },
                {
                    id: 5,
                    selected: true,
                },
                {
                    id: 6,
                    selected: true,
                },
            ]);
            return getMyUser(user)
                .then((res) => {
                    console.log(res.data.data.clinic.surveySettings.sort(((a, b) => a.language.id - b.language.id))[0].bodyMetrics);
                    const bodyMetrics = res.data.data.clinic.surveySettings.sort(((a, b) => a.language.id - b.language.id))[0].bodyMetrics ?? [];

                    if (bodyMetrics.length > 0) {
                        setItems([
                            {
                                id: 1,
                                property: bodyMetrics[0].pdfName,
                                propertyName: "neck",
                            },
                            {
                                id: 2,
                                property: bodyMetrics[1].pdfName,
                                propertyName: "midBack",
                            },
                            {
                                id: 8,
                                property: bodyMetrics[2].pdfName,
                                propertyName: "lowerBack",
                            },
                            {
                                id: 9,
                                property: bodyMetrics[3].pdfName,
                                propertyName: "posture",
                            },
                            {
                                id: 3,
                                property: bodyMetrics[4].pdfName,
                                propertyName: "energyLevels",
                            },
                            {
                                id: 4,
                                property: bodyMetrics[5].pdfName,
                                propertyName: "abilityStress",
                            },
                            {
                                id: 5,
                                property: bodyMetrics[6].pdfName,
                                propertyName: "sleepQuality",
                            },
                            {
                                id: 6,
                                property: bodyMetrics[7].pdfName,
                                propertyName: "immuneSystem",
                            },
                            {
                                id: 7,
                                property: bodyMetrics[8].pdfName,
                                propertyName: "mentalState",
                            },
                            {
                                id: 10,
                                property: bodyMetrics[9].pdfName,
                                propertyName: "emotionalState",
                            },
                        ]);
                    } else {
                        setItems([
                            {
                                id: 1,
                                property: "neck",
                                propertyName: "neck",
                            },
                            {
                                id: 2,
                                property: "midBack",
                                propertyName: "midBack",
                            },
                            {
                                id: 8,
                                property: "lowerBack",
                                propertyName: "lowerBack",
                            },
                            {
                                id: 9,
                                property: "posture",
                                propertyName: "posture",
                            },
                            {
                                id: 3,
                                property: "energyLevels",
                                propertyName: "energyLevels",
                            },
                            {
                                id: 4,
                                property: "abilityStress",
                                propertyName: "abilityStress",
                            },
                            {
                                id: 5,
                                property: "sleepQuality",
                                propertyName: "sleepQuality",
                            },
                            {
                                id: 6,
                                property: "immuneSystem",
                                propertyName: "immuneSystem",
                            },
                            {
                                id: 7,
                                property: "mentalState",
                                propertyName: "mentalState",
                            },
                            {
                                id: 10,
                                property: "emotionalState",
                                propertyName: "emotionalState",
                            },
                        ]);
                    }
                });
        });
    }
  };

  useEffect(() => {
    getAllPractitioners(user).then((res) => {
      let allPractitioners = res.data;
      allPractitioners.unshift({ id: 0, name: user.user.clinic.name });
      setPractitioners(allPractitioners);
    });
  }, []);

  const onCheckboxClick = (index) => {
    surveyOptions[index].selected = !surveyOptions[index].selected;
    setSurveyOptions([...surveyOptions]);
    updateStatisticsAccordingToOptions();
  };

  const onTypeClick = (index) => {
    surveyType[index].selected = !surveyType[index].selected;
    setSurveyType([...surveyType]);

    const selectedTypeIds = surveyType
      .filter((item) => item.selected)
      .map((item) => item.id);

    getStatistics({ surveyTypes: selectedTypeIds, scaleType:selectedScale?.value }, user).then((res) => {
      updateStatisticsAccordingToOptions(res.data.data);
    });
  };


  const onScaleClick = (newScale) => {
    setSelectedScale(newScale);

    const selectedTypeIds = surveyType
        .filter((item) => item.selected)
        .map((item) => item.id);

    getStatistics({ surveyTypes: selectedTypeIds, scaleType:newScale?.value }, user).then((res) => {
      updateStatisticsAccordingToOptions(res.data.data);
    });
  };

  const updateStatisticsAccordingToOptions = (customStatistics = null) => {
    if (customStatistics) {
      statistics = customStatistics;
    }
    surveyOptions.forEach((o) => {
      const statisticIndex = statistics.findIndex((s) => {
        return s.surveyOrder === o.id;
      });
      if (o.selected === false) {
        if (statisticIndex !== -1) {
          statistics[statisticIndex].visible = false;
        }
      } else {
        if (statisticIndex !== -1) {
          statistics[statisticIndex].visible = true;
        }
      }
    });

    setStatistics([...statistics]);
  };
  const setSelected = (selected) => {
    setSelectedDiagram(selected);
  };

  console.log(user.user.clinic.name, "USER");

  return (
    <div className="Statistics">
      <div className="desktopView">
        <Headline
          text={i18n.t("globalStatistics")}
          type={"Headline-big-left"}
        />

          <div style={{
              display:'flex',
              gap:'20px'
          }}>
              <div className={"statisticsDropdownContainer"}>
                  <Dropdown
                      options={practitioners}
                      setSelectedOption={setSelectedPractitioner}
                      selectedOption={selectedPractitioner}
                      label="Select"
                      type={"statistics"}
                      placeholder="Select"
                      show={show}
                      excludeFirstOption={true}
                  />
              </div>

              <div className={"statisticsDropdownContainer"}>
                  <Dropdown
                      options={diagramTypes}
                      setSelectedOption={(selected) => setSelected(selected)}
                      selectedOption={selectedDiagram}
                      label={i18n.t("chooseDiagramType")}
                      type={"statistics"}
                      placeholder={i18n.t("diagramType")}
                  />
              </div>
          </div>




          <div style={{
              display:'flex',
              gap:'20px'
          }}>
              <div className={"statisticsDropdownContainer"}>
                  <Dropdown
                      options={surveyGlobalTypes}
                      setSelectedOption={async (newScale) => {
                          await setStatistics([])
                          await setItems([])
                          await setSurveyGlobalType(newScale)
                      }}
                      selectedOption={surveyGlobalType}
                      label={i18n.t("surveyGlobalType")}
                      type={"statistics"}
                      placeholder={i18n.t("surveyGlobalType")}
                  />
              </div>

              {
                  (clinicUsesOldScale && surveyGlobalType?.value === 'regular') && <div className={"statisticsDropdownContainer"}>
                      <Dropdown
                          options={scaleTypes}
                          setSelectedOption={(newScale) => onScaleClick(newScale)}
                          selectedOption={selectedScale}
                          label={i18n.t("chooseScaleType")}
                          type={"statistics"}
                          placeholder={i18n.t("scaleType")}
                      />
                  </div>
              }
          </div>





        <div className={"autoSelectContainer"}>
          {/*<div className={"autoSelectTitle"}>*/}
          {/*  {i18n.t("autoSelectStatistics")}*/}
          {/*</div>*/}
          <div className={"autoSelectBox"} style={{marginTop:'15px'}}>
            {surveyOptions?.map((s, index) => {
              return (
                <div className={"checkboxContainerBox"} key={index}>
                  <CustomCheckbox
                    value={s.selected}
                    setValue={() => onCheckboxClick(index)}
                  />
                  <div
                    className={"checkboxCustomLabel"}
                    onClick={() => onCheckboxClick(index)}
                  >
                    {" "}
                    {i18n.t("survey")} {s.id}{" "}
                  </div>
                </div>
              );
            })}
          </div>
          {(user.user.clinic.businessPlan.type === 1 || surveyGlobalType?.value === 'wellness')  ? (
            ""
          ) : (
            <div className={"autoSelectBox"}>
              {surveyType.map((item, index) => {
                return (
                  <div className={"checkboxContainerBox"} key={index}>
                    <CustomCheckbox
                      value={item.selected}
                      setValue={() => onTypeClick(index)}
                    />
                    <div
                      className={"checkboxCustomLabel"}
                      onClick={() => {
                        onTypeClick(index);
                      }}
                    >
                      {item.name}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {items.map((item, index) => {
          if (selectedDiagram.id === 1 && surveyGlobalType?.value === 'regular')
            return (
              <div key={index}>
                <BarChart
                  values={statistics}
                  surveyOptions={surveyOptions}
                  property={item.property}
                  propertyName={item.propertyName}
                  id={item.id}
                />
              </div>
            );

          if (selectedDiagram.id === 2 && surveyGlobalType?.value === 'regular')
            return (
              <div key={index}>
                <XYDiagram
                    showZero={selectedScale?.value !== 'one_scale'}
                  values={statistics}
                  surveyOptions={surveyOptions}
                    property={item.property}
                    propertyName={item.propertyName}
                  id={item.id}
                />
              </div>
            );

            if (selectedDiagram.id === 1 && surveyGlobalType?.value === 'wellness')
                return (
                    <div key={index}>
                        <BarChartWellness
                            values={statistics}
                            surveyOptions={surveyOptions}
                            property={item.property}
                            propertyName={item.propertyName}
                            id={item.id}
                        />
                    </div>
                );

            if (selectedDiagram.id === 2 && surveyGlobalType?.value === 'wellness')
                return (
                    <div key={index}>
                        <XYDiagramWellness
                            values={statistics}
                            surveyOptions={surveyOptions}
                            property={item.property}
                            propertyName={item.propertyName}
                            id={item.id}
                        />
                    </div>
                );
        })}

        {/* {loader ? (
          <>
            {items.map((item, index) => {
              if (selectedDiagram.id === 1)
                return (
                  <div key={index}>
                    <BarChart
                      values={statistics}
                      surveyOptions={surveyOptions}
                      property={item.property}
                      id={item.id}
                    />
                  </div>
                );

              if (selectedDiagram.id === 2)
                return (
                  <div key={index}>
                    <XYDiagram
                      values={statistics}
                      surveyOptions={surveyOptions}
                      property={item.property}
                      id={item.id}
                    />
                  </div>
                );
            })}
          </>
        ) : (
          <Dna
            visible={true}
            height="80"
            width="80"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        )} */}
      </div>
      <div className="mobileView">{i18n.t("desktopView")}</div>
    </div>
  );
};

export default Statistics;
